import React, {Component, Suspense} from "react";
import {get, post} from "../helper/request";
import {error_manager} from "../helper/error_manager";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import queryString from "query-string";
import {
    Autocomplete,
    Box,
    Button,
    Collapse,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    ThemeProvider,
    Typography
} from "@mui/material";
import {Empty, message, Popover, Select, Spin} from "antd";
import {copyToClipboard, isNull, notNull, openEndPoint} from "../utils/utils";
import {monthMapping} from "../utils/const";
import {updateScannerData} from "../redux_actions/gamma.state.action";
import {connect} from "react-redux";
import "../asset/style/style.css";
import {DataGrid} from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import Draggable from "react-draggable";
import _ from "lodash";
import {Link} from "react-router-dom";
import {InfoCircleOutlined} from "@ant-design/icons";
import {defaultTheme} from "../component/gammaviewer/themes";
import {isCloud} from "../utils/utils";
const Plot = React.lazy(() => import("react-plotly.js"));

const sortableHeaders = [
    {
        id: 'name',
        field: 'name',
        headerName: 'Name',
        flex: 2
    },
    {
        id: 'status',
        field: 'status',
        headerName: 'Status',
        flex: 2
    },
    {
        id: 'area',
        field: 'area',
        headerName: 'Area',
        flex: 1
    },
    {
        id: 'x_tilt',
        field: 'x_tilt',
        headerName: 'X Tilt',
        flex: 1
    },
    {
        id: 'y_tilt',
        field: 'y_tilt',
        headerName: 'Y tilt',
        flex: 1
    },
    {
        id: 'export',
        field: 'export',
        headerName: 'Export',
        flex: 2
    },
    {
        id: 'upload',
        field: 'upload',
        headerName: 'Upload',
        flex: 1
    },
    {
        id: 'speed',
        field: 'speed',
        headerName: 'Speed',
        flex: 1
    },
    {
        id: 'specimen',
        field: 'specimen',
        headerName: 'Specimen Type',
        flex: 1
    },
    {
        id: 'time',
        field: 'time',
        headerName: 'Time',
        flex: 2,
        renderCell: (params) => <Grid container direction="column">
            {Object.entries(params.row['time']).map(([key, value]) => (
                key === "total_time" && typeof value === "string" ?
                    <Grid item><strong>{key}:</strong> {value}</Grid> : key === "total_time" ?
                        <Grid item><strong>{key}:</strong> {Math.round((value + Number.EPSILON) * 100) / 100}</Grid> :
                        <Grid item>{key}: {Math.round((value + Number.EPSILON) * 100) / 100}</Grid>
            ))}
        </Grid>
    },
    {
        id: 'size',
        field: 'size',
        headerName: 'Size',
        flex: 3,
        renderCell: (params) => <Grid container direction="column">
            {Object.entries(params.row['size']).map(([key, value]) => (
                <Grid item><strong>{key}:</strong> {value}</Grid>
            ))}
        </Grid>
    },
    {
        id: 'stitched',
        field: 'stitched',
        headerName: 'Stitched Info',
        flex: 2,
        renderCell: (params) => <Grid container direction="column">
            <Grid item>Stitched xMax: {params.row['stitched_x_max']}</Grid><Divider/>
            <Grid item>Stitched yMax: {params.row['stitched_y_max']}</Grid><Divider/>
            <Grid item>Stitched tileWidth: {params.row['stitched_tile_width']}</Grid><Divider/>
            <Grid item>Stitched tileHeight: {params.row['stitched_tile_height']}</Grid>
        </Grid>
    },
]

const PaperComponent = (props) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

class ScannerAnalysis extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            scanData: {},
            summaryData: {},
            lastUpdatedData: {},
            hourlyMachineData: {},
            scanners: {},
            countryOptions: [],
            stateOptions: [],
            scannerOptions: [],
            openAnchor: null,
            openDialog: null,
            selectedMonth: new Date().getMonth(),
            selectedYear: new Date().getFullYear(),
            currentYear: new Date().getFullYear(),
            selectedCountry: "",
            selectedState: "",
            isDataFetched: false
        }
    }

    componentDidMount() {
        this.getScannersName();
    }

    getScannerDataFromURL() {
        let scanner_name = window.location.href.split('=')[1]
        if (notNull(scanner_name)) {
            const scanner_data = this.state.scanners.find(o => o.scanner_name === scanner_name);
            this.props.dispatch(updateScannerData(scanner_data));
            this.getScansData();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (_.size(prevState.scanners) !== _.size(this.state.scanners)){
            this.getScannerDataFromURL();
            this.getCountryOptions(this.state.scanners)
            this.getStateOptions(this.state.scanners)
            this.getScannerOptions();
        }
        if (prevState.selectedCountry !== this.state.selectedCountry){
            this.getStateOptions(this.state.scanners)
            this.getScannerOptions()
        }
        if (prevState.selectedState !== this.state.selectedState) {
            this.getScannerOptions()
        }
    }

    handleDropdownClose = (clickedIndex) => {
        if (this.state.openAnchor === clickedIndex)
            this.setState({openAnchor: null});
        else
            this.setState({openAnchor: clickedIndex});
    };

    getScannersName = () => {
        this.setState({isFetching: true});
        get('/api/get_scanners_folders')
            .then(response => {
                this.setState({isFetching: false, scanners: response['scanners']});
            })
            .catch(error => {
                this.setState({isFetching: false});
                error_manager("Error in fetching Scanner Names", error)
            })
    }

    getScansData = () => {
        this.setState({isDataFetched: true});
        let data = {
            scanner_name: this.props.scannerData['scanner_name'],
            year: this.state.selectedYear,
            month: this.state.selectedMonth + 1,
        }
        post('/api/fetch_scanner_analysis_data/', queryString.stringify(data))
            .then(response => {
                this.setState({
                    isDataFetched: false, scanData: response['scansData'], hourlyMachineData: response['hourlyMachine'],
                    summaryData: response['summary'], lastUpdatedData: response['lastUpdated']
                })
            })
            .catch(error => {
                this.setState({isDataFetched: false});
                error_manager("No data for the applied filters", error)
            })
    }

    handleYearChange = (value) => this.setState({selectedYear: value});
    handleMonthChange = (value) => this.setState({selectedMonth: value});
    handleCountryChange = (value) => this.setState({selectedCountry: value});
    handleStateChange = (value) => this.setState({selectedState: value});

    reverseSizeFmt(strSize, suffix = 'B') {
        let num = 1;
        const units = ['.0', 'Ki', 'Mi', 'Gi', 'Ti', 'Pi', 'Ei', 'Zi', 'Yi'];
        for (let unit of units) {
            if (!strSize.includes(unit + suffix)) {
                num *= 1024;
            } else {
                let val = parseFloat(strSize.replace(unit + suffix, ""));
                return num * val;
            }
        }
        throw new Error("Invalid Input");
    }

    outputSizeFmt(sizeInBytes) {
        if (sizeInBytes < 1024) {
            return sizeInBytes + ' B';
        }
        const units = ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let size = sizeInBytes;
        let unitIndex = 0;
        size /= 1024;
        while (size >= 1024 && unitIndex < units.length - 1) {
            size /= 1024;
            unitIndex++;
        }
        return size.toFixed(2) + ' ' + units[unitIndex];
    }

    getYearOptions = () => {
        let yearOptions = [];
        for (let i = 2018; i <= new Date().getFullYear(); i++)
            yearOptions.push(
                <MenuItem value={i}>{i}</MenuItem>
            )
        return yearOptions;
    }

    getMonthOptions = () => {
        let monthOptions = [];
        monthOptions.push(
            <MenuItem value={12}>{monthMapping[13]}</MenuItem>
        )
        if (this.state.selectedYear !== undefined && (this.state.currentYear !== this.state.selectedYear)) {
            for (let i = 1; i <= 12; i++)
                monthOptions.push(
                    <MenuItem value={i - 1}>{monthMapping[i]}</MenuItem>
                )
            return monthOptions;
        }
        for (let i = 1; i <= new Date().getMonth() + 1; i++)
            monthOptions.push(
                <MenuItem value={i - 1}>{monthMapping[i]}</MenuItem>
            )
        return monthOptions;
    }

    getCountryOptions = (scanners) => {
        if (_.size(scanners) === 0)
            return [];
        const countrySet = new Set();
        const countryArray = [];

        // Loop through the data to collect unique country names
        scanners.forEach(item => {
            const country = item.customer_country;
            if (country !== null && country !== undefined) {
                countrySet.add(country);
            }
        });

        countrySet.forEach(item => {
            countryArray.push(<MenuItem value={item}>{item}</MenuItem>)
        })

        this.setState({countryOptions: countryArray});
    };

    getStateOptions = (scanners) => {
        const stateSet = new Set();
        const stateArray = [];

        // Loop through the data to collect states of the selected country
        scanners.forEach(item => {
            if (item.customer_state !== undefined && item.customer_state !== null) {
                stateSet.add(item.customer_state);
            }
        });

        stateSet.forEach(item => {
            stateArray.push(<MenuItem value={item}>{item}</MenuItem>)
        })

        this.setState({stateOptions: stateArray, selectedState: ""});
    };

    getScanCount = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {
                Object.keys(val).map((key) => {
                    let value = val[key];
                    if (key === "failed") {
                        return (<><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong></Grid><Divider/>
                            {Object.keys(value).map((f_key) => {
                                return <Grid item>{f_key[0].toUpperCase() + f_key.slice(1)}: {value[f_key]}</Grid>
                            })
                            }
                            <Divider/>
                        </>)
                    }
                    return <><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong> {value}
                    </Grid><Divider/></>
                })
            }
        </Grid>
    }

    getSummaryScanSize = (val, totalScans) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {Object.entries(val).map(([key, value]) => (
                <Grid item>
                    <strong>{key}: </strong>
                    {value.split(".")[1].replace(/[0-9]+/, "") === 'GiB' ?
                        `${Math.round(((parseFloat(value.toLowerCase().split(/[a-z]/g)) * 1024) / totalScans + Number.EPSILON) * 100) / 100} MiB` :
                        value.split(".")[1].replace(/[0-9]+/, "") === 'TiB' ?
                            `${Math.round(((parseFloat(value.toLowerCase().split(/[a-z]/g)) * 1024 * 1024) / totalScans + Number.EPSILON) * 100) / 100} MiB` :
                            `${Math.round((parseFloat(value.toLowerCase().split(/[a-z]/g)) / totalScans + Number.EPSILON) * 100) / 100} MiB`
                    }
                </Grid>
            ))}
        </Grid>
    }

    getScanSpeed = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {Object.keys(val).map((key) => {
                    return <Grid item>{key.toUpperCase()}: {val[key]}</Grid>
                })
            }
        </Grid>
    }

    getSpecimenType = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
        {Object.keys(val).map((key) => {
                return <Grid item>{key.toUpperCase()}: {val[key]}</Grid>
            })
        }
        </Grid>
    }

    getScanSize = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {
                Object.keys(val).map((key) => {
                    let value = val[key];
                    if (key === "failed") {
                        return (<><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong></Grid><Divider/>
                            {Object.keys(value).map((f_key) => {
                                return <Grid item>{f_key[0].toUpperCase() + f_key.slice(1)}: {value[f_key]}</Grid>
                            })
                            }
                            <Divider/>
                        </>)
                    }
                    return <><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong> {value}
                    </Grid><Divider/></>
                })
            }
        </Grid>
    }

    getScanAreaSumm = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {
                Object.keys(val).map((key) => {
                    let value = val[key];
                    if (key === "failed") {
                        return (<><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong></Grid><Divider/>
                            {Object.keys(value).map((f_key) => {
                                return <Grid item>{f_key[0].toUpperCase() + f_key.slice(1)}: {value[f_key]}</Grid>
                            })
                            }
                            <Divider/>
                        </>)
                    }
                    return <><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong> {value}
                    </Grid><Divider/></>
                })
            }
        </Grid>
    }

    getOtherDetails = (scano, morpheus) => {
        if (isNull(scano)) return;
        return <Grid container direction="column">
            <Grid item>Scano: <strong>{scano}</strong></Grid>
            <Grid item>Morpheus: <strong>{morpheus}</strong></Grid>
        </Grid>
    }

    scansOnDate = (val) => {
        if (isNull(val)) return;
        let sortedScanDates = Object.keys(val).sort().reduce((scanDates, key) => {
            scanDates[key] = val[key];
            return scanDates;
        }, {});
        return <Grid container direction="column">
            {Object.entries(sortedScanDates).map(([date, scansCount]) => (
                <Grid item>
                    <strong>{date}</strong> : {scansCount}
                </Grid>
            ))}
        </Grid>
    }

    scansOnMonth = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {Object.values(val).map(month => (
                month.total ? <Grid item><strong>{monthMapping[month.id]}</strong> : {month.total}</Grid> :
                    <Grid item><strong>{monthMapping[month.id]}</strong> : {0}</Grid>
            ))}
        </Grid>
    }

    getPlot = (data, isYear) => {
        if (isNull(data)) return;
        let plotData;
        if (isYear) {
            let x = [], y = [];
            Object.values(data).forEach((i, index) => {
                x[index] = monthMapping[i.id];
                y[index] = i.total ? i.total : 0;
            });
            plotData = {
                x: x, y: y,
                type: "scatter",
                mode: "lines+markers",
                marker: {color: "red"},
                name: "Date v/s Total Scans"
            }
        } else {
            let sortedScanDates = Object.keys(data).sort().reduce((scanDates, key) => {
                scanDates[key] = data[key];
                return scanDates;
            }, {});
            plotData = {
                x: Object.keys(sortedScanDates),
                y: Object.values(sortedScanDates),
                type: "scatter",
                mode: "lines+markers",
                marker: {color: "red"},
                name: "Date v/s Total Scans"
            }
        }
        return <Suspense fallback={<div>Loading...</div>}><Plot data={[plotData]}/></Suspense>
    }

    getHourlyPlot = (data) => {
        if (isNull(data)) return;
        const layout = {
            autosize: true,
            xaxis: {title: "Date"},
            yaxis: {title: "Time when Machine/Internet Up"},
        };
        let plotData1 = Object.entries(data['machine_up']).map(([key, value]) => {
            let size = Object.keys(value).length;
            return {
                x: Array(size).fill(key),
                y: Object.keys(value),
                type: "scatter",
                mode: "markers",
                marker: {color: "red"},
                name: "Date v/s Machine Up"
            }
        });
        let plotData2 = Object.entries(data['internet_up']).map(([key, value]) => {
            let size = Object.keys(value).length;
            return {
                x: Array(size).fill(key),
                y: Object.keys(value),
                type: "scatter",
                mode: "markers",
                marker: {color: "blue"},
                name: "Date v/s Internet Up"
            }
        });
        const plotData = plotData1.concat(plotData2);
        return <Suspense fallback={<div>Loading...</div>}><Plot data={plotData} layout={layout}/></Suspense>
    }

    handleDialogOpen = () => this.setState({openDialog: true});

    handleDialogClose = () => this.setState({openDialog: false});

    getSummaryInfo = (val) => {
        if (isNull(val)) return;
        return <TableRow key={val['month']} sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.2)'}}}>
            <TableCell component="th" scope="row">
                {this.scansOnDate(val['scans_on_dates'])}
            </TableCell>
            <TableCell
                align="left">{this.getSummaryScanSize(val['size'], val['summarized_scan_count']['total'])}</TableCell>
            <TableCell align="left">{val['last_updated_readable']}</TableCell>
            <TableCell align="left">{this.getPlot(val['scans_on_dates'], false)}</TableCell>
        </TableRow>
    }

    getScanInfo = (val) => {
        if (isNull(val)) return;
        return Object.values(val).map((scanInfo, index) => {
            let scanArea = scanInfo['area'] || 0;
            return (
                {
                    id: index + 1,
                    name: scanInfo['name'],
                    status: scanInfo['status'],
                    area: Math.round((parseFloat(scanArea.toString()) + Number.EPSILON) * 100) / 100,
                    x_tilt: scanInfo['x_um_per_mm'] || 0,
                    y_tilt: scanInfo['y_um_per_mm'] || 0,
                    export: scanInfo['export_status'] ,
                    upload: scanInfo['upload_status'],
                    speed: scanInfo['scan_speed'],
                    specimen: scanInfo['specimen_type'],
                    time: scanInfo['time'],
                    size: scanInfo['size'],
                    stitched_x_max: scanInfo['stitched_x_max'],
                    stitched_y_max: scanInfo['stitched_y_max'],
                    stitched_tile_height: scanInfo['stitched_tile_height'],
                    stitched_tile_width: scanInfo['stitched_tile_width'],
                }
            );
        })
    }

    getAverageScanTime = (scanTime, successScans) => {
        let avgScanTime;
        try {
            if (scanTime.split(" ")[1] === "Hours")
                avgScanTime = (parseFloat(scanTime.split(" ")[0]) * 60) / successScans;
            else
                avgScanTime = parseFloat(scanTime.split(" ")[0]) / successScans;
        } catch (e) {
            avgScanTime = parseFloat(scanTime) / successScans;
        }
        return `${Math.round((avgScanTime + Number.EPSILON) * 100) / 100} min`;
    }

    getAwsLink = (date, isSummary) => {
        let awsLink;
        if (this.props.scannerData){
            if (isSummary && this.state.selectedMonth + 1 < 10) {
                awsLink = `https://s3.console.aws.amazon.com/s3/buckets/morphle-scanner-analytics?prefix=${this.props.scannerData['scanner_name']}${this.state.selectedYear}/0${this.state.selectedMonth + 1}/&region=us-east-2`;
            } else if (isSummary && this.state.selectedMonth + 1 >= 10 && this.state.selectedMonth + 1 <= 12) {
                awsLink = `https://s3.console.aws.amazon.com/s3/buckets/morphle-scanner-analytics?prefix=${this.props.scannerData['scanner_name']}${this.state.selectedYear}/${this.state.selectedMonth + 1}/&region=us-east-2`;
            } else if (isSummary && this.state.selectedMonth + 1 >= 10 && this.state.selectedMonth + 1 === 13) {
                awsLink = `https://s3.console.aws.amazon.com/s3/buckets/morphle-scanner-analytics?prefix=${this.props.scannerData['scanner_name']}${this.state.selectedYear}/&region=us-east-2`;
            } else if (!isSummary && this.state.selectedMonth + 1 < 10) {
                awsLink = `https://s3.console.aws.amazon.com/s3/object/morphle-scanner-analytics?region=us-east-2&prefix=${this.props.scannerData['scanner_name']}${this.state.selectedYear}/0${this.state.selectedMonth + 1}/${date}.json`;
            } else {
                awsLink = `https://s3.console.aws.amazon.com/s3/buckets/morphle-scanner-analytics?region=us-east-2&prefix=${this.props.scannerData['scanner_name']}${this.state.selectedYear}/${this.state.selectedMonth + 1}/${date}.json`;
            }
        }
        return <a href={awsLink} target={"_blank"} rel="noreferrer">Location</a>
    }

    getTotalYearlyScansInfo = (monthsData) => {
        let scansTotal = 0, scansExported = 0, scansSuccess = 0, scansErrored = 0, scansInProgress = 0,
            scansCancelled = 0, necessarySize = 0, totalSize = 0, debugSize = 0;
        let scansFast = 0, scansMedium = 0, scansSlow = 0, scansZstack = 0;
        let scansHne = 0, scansPap = 0, scansIhc = 0, totalScanTime = 0;
        const scansOnMonths = [];
        let month = this.state.selectedYear === new Date().getFullYear() ? new Date().getMonth() + 1 : 12;
        for (let i = 0; i < month; i++) {
            scansOnMonths[i] = {id: i + 1}
        }
        Object.values(monthsData).forEach((data, index) => {
            scansTotal += data['summarized_scan_count']['total'];
            scansExported += data['summarized_scan_count']['exported'];
            scansSuccess += data['summarized_scan_count']['success'];
            scansErrored += data['summarized_scan_count']['failed']['errored'];
            scansInProgress += data['summarized_scan_count']['failed']['In_progress'];
            scansCancelled += data['summarized_scan_count']['failed']['cancelled'];
            scansFast += data['summarized_scan_speed']['FAST'];
            scansMedium += data['summarized_scan_speed']['MEDIUM'];
            scansSlow += data['summarized_scan_speed']['SLOW'];
            scansZstack += data['summarized_scan_speed']['ZSTACK'];
            scansHne += data['summarized_specimen_type']['HNE'];
            scansIhc += data['summarized_specimen_type']['IHC'];
            scansPap += data['summarized_specimen_type']['PAP'];
            necessarySize += this.reverseSizeFmt(data['size']['necessary_size_on_hdd'])
            totalSize += this.reverseSizeFmt(data['size']['total_size_on_hdd'])
            debugSize += this.reverseSizeFmt(data['size']['debug_size_on_hdd'])
            console.log(necessarySize);

            let sumTotalScanTime = data['sum_total_scan_time'];
            try {
                if (sumTotalScanTime.split(" ")[1] === "Hours")
                    totalScanTime += parseFloat(sumTotalScanTime.split(" ")[0]) * 60;
                else
                    totalScanTime += parseFloat(sumTotalScanTime.split(" ")[0]);
            } catch (e) {
                totalScanTime += parseFloat(sumTotalScanTime.toString());
            }
            scansOnMonths.forEach(object => {
                if (object.id === parseFloat(data['month'].split("/")[1])) {
                    object['total'] = data['summarized_scan_count']['total'];
                }
            });
        })
        const scansCount = {
            "success": scansSuccess,
            "total": scansTotal,
            "failed": {
                "errored": scansErrored,
                "cancelled": scansCancelled,
                "In_progress": scansInProgress,
                "total": scansTotal - scansSuccess,
            },
            "exported": scansExported,
        }
        const scansSpeed = {
            "FAST": scansFast,
            "MEDIUM": scansMedium,
            "SLOW": scansSlow,
            "ZSTACK": scansZstack
        }
        const scansSpecimen = {
            "HNE": scansHne,
            "IHC": scansIhc,
            "PAP": scansPap,
        }
        const scanSize = {
            "Necessary_size_on_hdd" : this.outputSizeFmt(necessarySize),
            "Total_size_on_hdd" : this.outputSizeFmt(totalSize),
            "Debug_size_on_hdd" : this.outputSizeFmt(debugSize)
        }
        const avgScanTime = totalScanTime / scansSuccess;
        return <>
            <TableRow key={-1}
                      sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.4)'}}}>
                <TableCell>
                    <IconButton
                        aria-label="expand row" size="small"
                        onClick={() => this.handleDropdownClose(-2)}>
                        {this.state.openAnchor === -2 ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row"><strong>Total: </strong>{this.state.selectedYear}
                </TableCell>
                <TableCell>{this.getScanCount(scansCount)}</TableCell>
                <TableCell align="right">{this.getScanSpeed(scansSpeed)}</TableCell>
                <TableCell align="right">{this.getSpecimenType(scansSpecimen)}</TableCell>
                <TableCell align="right">{this.getScanSize(scanSize)}</TableCell>
                <TableCell align="right">-</TableCell>
                <TableCell align="right">
                    <strong>Average Scan Time:</strong><br/>
                    {`${Math.round((avgScanTime + Number.EPSILON) * 100) / 100} min`}<br/>
                    <strong>Total Scan Time:</strong>{`${Math.round((totalScanTime + Number.EPSILON) * 100) / 100} min`}
                </TableCell>
                <TableCell align="right">{this.getAwsLink(this.state.selectedYear, true)}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                    <Collapse in={this.state.openAnchor === -2} timeout="auto" unmountOnExit>
                        <Box sx={{margin: 1}}>
                            <Typography variant="h6" gutterBottom component="div">
                                Summary Info
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Scans Count Date-Wise</TableCell>
                                        <TableCell align="left">Plot</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow key={'-1'} sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.2)'}}}>
                                        <TableCell component="th" scope="row">
                                            {this.scansOnMonth(scansOnMonths)}
                                        </TableCell>
                                        <TableCell align="left">{this.getPlot(scansOnMonths, true)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    }

    getScannerOptions = () => {
        let scanner = [];
        let j = 0;
        for (let i = 0; i < this.state.scanners.length; i++) {
            if (this.state.scanners[i]['scanner_name'].length >= 30) {
                if (this.state.selectedState !== ""){
                    if (this.state.scanners[i]['customer_state'] === this.state.selectedState)
                        scanner[j++] = this.state.scanners[i];
                }
                else if (this.state.selectedCountry !== ""){
                    if (this.state.scanners[i]['customer_country'] === this.state.selectedCountry)
                        scanner[j++] = this.state.scanners[i];
                }
                else {
                    scanner[j++] = this.state.scanners[i];
                }
            }
        }
        this.setState({scannerOptions: scanner})
    }

    getDiskStats = (data) => {
        if (isNull(data)) return;
        return <Grid container direction="column">
            {Object.entries(data).map(([space, info]) => (
                <Grid item>{space}: {`${Math.round((info + Number.EPSILON) * 100) / 100} GiB`}</Grid>
            ))}
        </Grid>
    }

    copyShareableLinkToClipboard = () => {
        let url = `${window.location.href.split("?")[0]}?`;
        url += `scanner_name=${this.props.scannerData['scanner_name']}`;
        copyToClipboard(url);
        message.info("Scanner Shareable Link Copied to Clipboard");
    }

    getSearchFilterInfoButton = () => {
        return <Popover content={
                        <div>
                            Select a Country and/or state to filter out the scanners appearing in the results accordingly<br/>
                            To add data for existing scanners, visit the <Link to={"/admin/api/scanneranalysis/"} target="_blank" rel="noopener noreferrer" >ScannerAnalysis</Link> Table in Admin Mode.<br />
                            Then Search for a particular time duration using Year and Month.
                        </div>
                    }
                    trigger="click"
                    placement="right">
            <InfoCircleOutlined style={{cursor: "pointer", marginLeft: "5px", fontSize: "16px"}} />
        </Popover>
    }

    changeColorBasedOnTime = (lastUpdatedData) => {
        let totalOffset = 0
        if (lastUpdatedData.timezone_offset){
            let offsetString = lastUpdatedData.timezone_offset;
            const [hoursStr, minutesStr, secondsStr] = offsetString.split(':').map(str => parseInt(str));
            totalOffset = Math.sign(hoursStr) * (Math.abs(hoursStr)*3600 + minutesStr * 60 + secondsStr);
        }

        let lastUpdatedTime = lastUpdatedData.last_updated - totalOffset
        let timeDifference = new Date().getUTCSeconds() - lastUpdatedTime
        if (timeDifference > (24*60*60*1000)){
            return {backgroundColor: "red"}
        }
        return {}
    }

    getPlots = (scanData) => {
        let x_tilt_data = []
        let y_tilt_data = []
        let time_data = []
        let area_data = []
        
        for (let objId in scanData) {
            if (scanData.hasOwnProperty(objId)) {
                x_tilt_data.push(scanData[objId]['x_um_per_mm']);
                y_tilt_data.push(scanData[objId]['y_um_per_mm']);

                if(scanData[objId]['time'] && scanData[objId]['time']['total_time'] && scanData[objId]['area']){
                    time_data.push(scanData[objId]['time']['total_time'])
                    area_data.push(scanData[objId]['area'])
                }
            }

            
        }

        return(
            <Suspense fallback={<div>Loading...</div>}>
                <Plot
                    data={[
                        {
                            "x": x_tilt_data,
                            "type": "histogram",
                            autobinx: false,
                            xbins: {
                            size: 0.2,
                            start: 0
                        }
                    }
                    ]}
                    layout = {{
                        bargap: 0.05, 
                        bargroupgap: 0.2,
                        title: "X Tilt", 
                        xaxis: {title: "x_um_per_mm"}, 
                        yaxis: {title: "Count"}
                    }}
                />

                <Plot
                    data={[
                        {
                            "x": y_tilt_data,
                            "type": "histogram",
                            autobinx: false,
                            xbins: {
                            size: 0.2,
                            start: 0
                        }
                    }
                    ]}
                    layout = {{
                        bargap: 0.05, 
                        bargroupgap: 0.2,
                        title: "Y Tilt", 
                        xaxis: {title: "y_um_per_mm"}, 
                        yaxis: {title: "Count"}
                    }}
                />

            <Plot
                data={[
                    {
                        "x": area_data,
                        "y": time_data,
                        'name': "AreaAndTime",
                        "type": "scatter",
                        "mode": "markers+text"
                    },
                    {
                        // x: tilt, y: num_scans
                    }
            ]}
                layout={{
                    height: 540,
                    title: 'Area v/s Time',
                    xaxis: {
                        title: {
                            text: 'Area',
                            font: {
                                family: 'Courier New, monospace',
                                size: 18,
                                color: '#7f7f7f'
                            }
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Time',
                            font: {
                                family: 'Courier New, monospace',
                                size: 18,
                                color: '#7f7f7f'
                            }
                        }
                    }
                }}
            />
            </Suspense>
        )
    }

    checkAndReturnIfNotCloud(){
        if(!isCloud()){
            return
        }
    }

    render() {
        const {
            scanData,
            summaryData,
            lastUpdatedData,
            openAnchor,
            isDataFetched,
            isFetching,
            hourlyMachineData
        } = this.state;

        if(!isCloud()){
            return (<div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <Typography>
                    You do not have permission to view this page
                </Typography>
            </div>)
        }

        return <ThemeProvider theme={defaultTheme}>
            <Spin spinning={isFetching || isDataFetched}>
                <Grid container spacing={3}>
                    <Grid item xs margin={3}>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={() => openEndPoint('/scannerAnalysisSummary')}
                                sx={{
                                    marginTop: '16px',
                                    marginLeft: '5px'
                                }}>
                            Get Scanners Summary
                        </Button>
                    </Grid>
                    <Grid item xs={6} margin={3}>
                        <Typography sx={{margin: '16px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px'}}>
                            Scanner Analysis Dashboard
                        </Typography>
                    </Grid>
                    <Grid item xs>
                    </Grid>
                </Grid>
                {notNull(lastUpdatedData) && Object.keys(lastUpdatedData).length !== 0 &&
                    <Typography className='last-updated-info' fontSize={'12px'}
                                style={this.changeColorBasedOnTime(lastUpdatedData)}>
                        <strong>Last Updated:</strong> {lastUpdatedData['last_updated_readable']}<br/>
                        <strong>Disks Stats ['/']:</strong>
                        {notNull(lastUpdatedData['disks_stat']) && notNull(lastUpdatedData['disks_stat']['/'])
                            && this.getDiskStats(lastUpdatedData['disks_stat']['/'])}
                        <strong>Disks Stats ['/media/scandrive']:</strong>
                        {notNull(lastUpdatedData['disks_stat']) && notNull(lastUpdatedData['disks_stat']['/media/scandrive'])
                            && this.getDiskStats(lastUpdatedData['disks_stat']['/media/scandrive'])}
                    </Typography>}
                <Grid
                    container
                    direction="row"
                    justifyContent="left"
                    alignItems="left"
                    margin={3}
                >
                    <Grid item xs={12}>
                        <Typography
                            sx={{margin: '16px', textAlign: 'flex-start', fontWeight: 'bold', fontSize: '20px'}}>
                            Search Filters {this.getSearchFilterInfoButton()}
                        </Typography>
                    </Grid>
                    <FormControl sx={{m: 1, minWidth: 180}}>
                        <FormHelperText>Select Country</FormHelperText>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={this.state.selectedCountry}
                            label="Country"
                            onChange={this.handleCountryChange}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {this.state.countryOptions}
                        </Select>
                    </FormControl>
                    <FormControl sx={{m: 1, minWidth: 180}}>
                        <FormHelperText>Select State</FormHelperText>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={this.state.selectedState}
                            label="State"
                            onChange={this.handleStateChange}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {this.state.stateOptions}
                        </Select>
                    </FormControl>
                    <Grid item xs={8}></Grid>
                    <Autocomplete sx={{m: 1, minWidth: 380}}
                                  value={this.props.scannerData}
                                  onChange={(event, newValue) => {
                                      let selectedVal;
                                      for (let i = 0; i < this.state.scanners.length; i++) {
                                          if (newValue !== null && newValue !== undefined && newValue['scanner_name'].includes(this.state.scanners[i]['scanner_name'])) {
                                              selectedVal = this.state.scanners[i];
                                              break;
                                          }
                                      }
                                      this.props.dispatch(updateScannerData(selectedVal));
                                  }}
                                  options={this.state.scannerOptions}
                                  getOptionLabel={(option) => {
                                      if (option && option['scanner_name']) {
                                          if (option['customer_name']) {
                                              return `${option['customer_name']} (${option['scanner_name'].slice(0, -30)})`;
                                          }
                                          return `${option['scanner_name'].slice(0, -30)}`;
                                      }
                                      return ""
                                  }}
                                  renderInput={(params) => (
                                      <TextField
                                          {...params}
                                          label="Scanner Name"
                                          variant="outlined"
                                      />
                                  )}
                                  required={true}
                    />

                    <FormControl sx={{m: 1, minWidth: 180}}>
                        <FormHelperText>Select Year</FormHelperText>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={this.state.selectedYear}
                            label="Year"
                            onChange={this.handleYearChange}
                        >
                            {this.getYearOptions()}
                        </Select>
                    </FormControl>
                    <FormControl sx={{m: 1, minWidth: 180}}>
                        <FormHelperText>Select Month</FormHelperText>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={monthMapping[this.state.selectedMonth + 1]}
                            label="Month"
                            onChange={this.handleMonthChange}
                        >
                            {this.getMonthOptions()}
                        </Select>
                    </FormControl>

                    <Button onClick={this.getScansData}
                            color="primary"
                            variant="outlined"
                            sx={{
                                marginTop: '16px',
                                marginLeft: '5px'
                            }}
                            disabled={this.props.scannerData === undefined || this.props.scannerData['scanner_name'] === null || this.props.scannerData['scanner_name'] === undefined || this.props.scannerData['scanner_name'] === ""}>
                        Get Data
                    </Button>
                    <Button onClick={this.copyShareableLinkToClipboard}
                            color="primary"
                            variant="outlined"
                            sx={{
                                marginTop: '16px',
                                marginLeft: '5px'
                            }}
                            disabled={this.props.scannerData === undefined || this.props.scannerData['scanner_name'] === null || this.props.scannerData['scanner_name'] === undefined || this.props.scannerData['scanner_name'] === ""}
                    >
                        Get Shareable Link
                    </Button>
                    {Object.keys(hourlyMachineData).length !== 0 && <>
                        <Button onClick={this.handleDialogOpen}
                                color="primary"
                                variant="outlined"
                                sx={{
                                    marginTop: '16px',
                                    marginLeft: '5px'
                                }}>
                            Open Hourly Plot
                        </Button>
                        <Dialog
                            open={this.state.openDialog}
                            onClose={this.handleDialogClose}
                            PaperComponent={PaperComponent}
                            // sx={{width: '500px'}}
                            aria-labelledby="draggable-dialog-title"
                        >
                            <DialogTitle style={{cursor: 'move'}} id="draggable-dialog-title">
                                Hourly up Plot (In User's Local TimeZone)
                            </DialogTitle>
                            <DialogContent>
                                {this.getHourlyPlot(hourlyMachineData)}
                            </DialogContent>
                            <DialogActions>
                                <Button autoFocus onClick={this.handleDialogClose}>
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </>}
                </Grid>
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell/>
                                <TableCell sx={{fontWeight: 'bold'}}>Date</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}}>Scans Count</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Scan Speed</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Specimen Type</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Size</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Area</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Branch details</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">AWS Link</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.selectedMonth + 1 !== 13 ? null :
                                summaryData[0] && summaryData[0]['month'] && this.getTotalYearlyScansInfo(summaryData)}
                            {Object.values(summaryData).map((summary, index) => {
                                if (!(summary && summary['month']))
                                    return
                                let sum_total_scan_time = null;
                                let unit = null;
                                try {
                                    sum_total_scan_time = Math.round((parseFloat(summary['sum_total_scan_time'].split(" ")[0]) + Number.EPSILON) * 100) / 100;
                                    unit = summary['sum_total_scan_time'].split(" ")[1]
                                } catch (e) {
                                    sum_total_scan_time = Math.round((parseFloat(summary['sum_total_scan_time'].toString()) + Number.EPSILON) * 100) / 100;
                                    unit = "Minutes";
                                }
                                return <>
                                    <TableRow key={summary['month']}
                                              sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.4)'}}}>
                                        <TableCell>
                                            <IconButton
                                                aria-label="expand row" size="small"
                                                onClick={() => this.handleDropdownClose(index - 1)}>
                                                {openAnchor === index - 1 ? <KeyboardArrowUpIcon/> :
                                                    <KeyboardArrowDownIcon/>}
                                            </IconButton>
                                        </TableCell>
                                        <TableCell component="th" scope="row"><strong>Total: </strong>{summary['month']}
                                        </TableCell>
                                        <TableCell>{this.getScanCount(summary['summarized_scan_count'])}</TableCell>
                                        <TableCell
                                            align="right">{this.getScanSpeed(summary['summarized_scan_speed'])}</TableCell>
                                        
                                        <TableCell
                                            align="right">{this.getSpecimenType(summary['summarized_specimen_type'])}</TableCell>
                                        <TableCell
                                            align="right">{this.getScanSize(summary['size'])}</TableCell>
                                        <TableCell
                                            align="right">{this.getScanAreaSumm(summary['summarized_area'])}</TableCell>
                                        <TableCell align="right">
                                            <strong>Average Scan Time:</strong><br/>
                                            {this.getAverageScanTime(summary['sum_total_scan_time'], summary['summarized_scan_count']['success'])}<br/>
                                            <strong>Total Scan Time:</strong>
                                            {`${sum_total_scan_time} ${unit}`}
                                        </TableCell>
                                        <TableCell align="right">{this.getAwsLink(summary['month'], true)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={10}>
                                            <Collapse in={openAnchor === index - 1} timeout="auto" unmountOnExit>
                                                <Box sx={{margin: 1}}>
                                                    <Typography variant="h6" gutterBottom component="div">
                                                        Summary Info
                                                    </Typography>
                                                    <Table size="small" aria-label="purchases">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Scans Count Date-Wise</TableCell>
                                                                <TableCell align="left">Average Size</TableCell>
                                                                <TableCell align="left">Last Updated</TableCell>
                                                                <TableCell align="left">Plot</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {this.getSummaryInfo(summary)}
                                                        </TableBody>
                                                    </Table>
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </>
                            })}
                            {this.state.selectedMonth + 1 !== 13 && scanData.length === 0 ?
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"No Data"}/> :
                                Object.entries(scanData).map(([key, value], index) => {
                                    return (
                                        value && value['summarized_data'] && value['summarized_data']['summarized_scan_count'] && <>
                                            <TableRow key={value['date']}
                                                      sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.4)'}}}>
                                                <TableCell>
                                                    <IconButton
                                                        aria-label="expand row" size="small"
                                                        onClick={() => this.handleDropdownClose(index)}>
                                                        {openAnchor === index ? <KeyboardArrowUpIcon/> :
                                                            <KeyboardArrowDownIcon/>}
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {value['date']}
                                                </TableCell>
                                                <TableCell>{this.getScanCount(value['summarized_data']['summarized_scan_count'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getScanSpeed(value['summarized_data']['summarized_scan_speed'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getSpecimenType(value['summarized_data']['summarized_specimen_type'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getScanSize(value['summarized_data']['size'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getScanAreaSumm(value['summarized_data']['summarized_area'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getOtherDetails(value['scano_branch'], value['morpheus_branch'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getAwsLink(value['date'], false)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={10}>
                                                    <Collapse in={openAnchor === index} timeout="auto" unmountOnExit>
                                                        <Box sx={{margin: 1}}>
                                                            {this.getPlots(value['scans_data'])}
                                                            <Typography variant="h6" gutterBottom component="div">
                                                                Scans Info
                                                            </Typography>
                                                            <DataGrid
                                                                initialState={{}}
                                                                disableRowSelectionOnClick
                                                                autoHeight
                                                                columns={sortableHeaders}
                                                                rows={this.getScanInfo(value['scans_data'])}
                                                                getRowHeight={() => 'auto'}
                                                            />
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Spin>
        </ThemeProvider>
    }
}

const mapStateToProps = (state) => {
    let {activeMapId, scannerData} = state.gammaStateReducer;
    return {scannerData, activeMapId};
}

export default connect(mapStateToProps)(ScannerAnalysis);